import { render } from "./Training.vue?vue&type=template&id=a73a1db4&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"

import "@suadelabs/vue3-multiselect/dist/vue3-multiselect.css?vue&type=style&index=0&lang=css"
import "./Training.vue?vue&type=style&index=1&id=a73a1db4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/1-fbk-tabor/1-fbk-tabor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a73a1db4"]])

export default __exports__